import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PaymentMethodNew from "@features/settings/components/PaymentMethodNew";
import "@features/settings/components/Payment.css";

const PaymentModal = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="payment-modal-new"
    >
      <Modal.Header closeButton className="payment-modal-header-new">
        <Modal.Title className="payment-modal-title-new">
          {t("payment.modalTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="payment-modal-body-new">
        <PaymentMethodNew handleClose={onClose} />
      </Modal.Body>
    </Modal>
  );
};

export default PaymentModal;

